import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Badge } from 'components/badge'
import { useLazyQuery } from '@apollo/client'
import { GET_MASTER_ROUTE_LIST } from 'graphql/route/queries'

export function RouteListMasterDropdown({ fields, other, onChangeData }) {
  const { t } = useTranslation()
  console.log('fields-fields--', fields)
  console.log('other-ddd--', other)

  const [routeMasterList, setRouteMasterList] = useState([])

  const [getMasterRouteList, { loading: routeListLoading, error: routeListError }] = useLazyQuery(
    GET_MASTER_ROUTE_LIST,
    {
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      onCompleted: data => {
        if (data.getMasterBoatRoute.success && data.getMasterBoatRoute.code === '200') {
          setRouteMasterList(data.getMasterBoatRoute.master_boat_routes)
        }
      },
    }
  )

  // get Type List
  const getLocations = () => {
    getMasterRouteList({
      variables: {
        page: {
          limit: 100,
          offset: 0,
        },
        routeId: null,
        routeName: null,
        statusCode: null,
      },
    })
  }
  useEffect(() => {
    getLocations()
  }, [])

  const onChangeHandler = e => {
    console.log('e.target.value--', e.target.value)
    // Set the value to the form
    fields.onChange(e)
    // find the selected item
    const selectedItem = routeMasterList.find(item => item.master_route_id === e.target.value)
    console.log('selectedItem--', selectedItem)
    if (selectedItem) {
      onChangeData({
        route_name: selectedItem.route_name,
        master_route_id: selectedItem.master_route_id,
        status: selectedItem.status,
        waypoints: selectedItem.waypoints,
      })
    }
  }
  return (
    <>
      {routeListLoading && <div className="flex justify-center items-center bg-white py-5">Loading ....</div>}
      {routeListError && (
        <div className="flex justify-center items-center bg-white py-5">
          <div className="text-lg text-center">{t('Failed to fetch locations')}</div>
        </div>
      )}
      {!routeListLoading && !routeListError && routeMasterList?.length === 0 && (
        <div className="flex justify-center items-center bg-white py-5">
          <div className="text-lg text-center">{t('No locations found!')}</div>
        </div>
      )}
      {!routeListLoading && !routeListError && routeMasterList?.length > 0 && (
        <select
          {...fields}
          // disabled={fields.disabled}
          onChange={onChangeHandler}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:max-w-full sm:text-sm sm:leading-6"
        >
          <option value="" label="Select a Route" />
          {/* {purpose === 'filter' ? <option value={null}> {t('All')} </option> : <option value="" disabled> {t('Select Location')} </option>} */}
          {routeMasterList.map(route => (
            <option key={route.master_route_id} value={route.master_route_id}>
              {route.route_name.en} -
              <Badge
                color={
                  route.status?.code === 'ACT'
                    ? 'emerald'
                    : route.status?.code === 'INA'
                      ? 'red'
                      : 'rose'
                }
              >
                {route.status?.description?.en}
              </Badge>
            </option>
          ))}
        </select>
      )}
    </>
  )
}
